module.exports = __webpack_public_path__ + "static/media/5.3b47f042.svg";